export default __webpack_public_path__ + "static/media/SC_prj2.47671cce.jpg";